import { render } from "./PredictionTable.vue?vue&type=template&id=77cd74e8"
import script from "./PredictionTable.vue?vue&type=script&lang=js"
export * from "./PredictionTable.vue?vue&type=script&lang=js"

import "./PredictionTable.vue?vue&type=style&index=0&id=77cd74e8&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__